export default "__VITE_ASSET___ewJD0zO9$SsiDvawfmAUw__";